import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import React from 'react';
import { BadgePreviewModal } from '../components/BadgePreviewModal';
export function showBadgePreviewModal(badgePreviewContext, badgeTemplateData) {
    showCustomDialog({
        maxWidth: 'xs',
        content: (close, ariaTitleId, ariaContentId) => (React.createElement(BadgePreviewModal, { ariaTitleId: ariaTitleId, ariaContentId: ariaContentId, badgeTemplateData: badgeTemplateData, badgePreviewContext: badgePreviewContext, close: close })),
        onEscapeKeyDown: (close) => close(),
    });
}
